(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ---------- Drag to scroll (mouse). Touch uses native scrolling. ---------- */
    function makeDrag(el, isolate) {
      if (!el) return;
      var down = false, moved = false, startX = 0, startScroll = 0;

      el.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        if (isolate) e.stopPropagation(); /* product slider must not drag the main slider */
        down = true;
        moved = false;
        startX = e.pageX;
        startScroll = el.scrollLeft;
      });

      window.addEventListener('mousemove', function (e) {
        if (!down) return;
        var dx = e.pageX - startX;
        if (!moved && Math.abs(dx) > 5) {
          moved = true;
          el.classList.add('is-dragging');
        }
        if (moved) {
          e.preventDefault();
          el.scrollLeft = startScroll - dx;
        }
      });

      window.addEventListener('mouseup', function () {
        if (!down) return;
        down = false;
        el.classList.remove('is-dragging');
      });

      /* Block the link / play click that ends a drag */
      el.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);

      el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    /* ---------- Video ---------- */
    function stopVideo(slide) {
      var video = slide.querySelector('[data-stl-video]');
      slide.classList.remove('is-playing');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }

    function initVideos(section) {
      var activeSlide = null;
      section.querySelectorAll('[data-stl-slide]').forEach(function (slide) {
        var video = slide.querySelector('[data-stl-video]');
        var playBtn = slide.querySelector('[data-stl-play]');
        if (!video || !playBtn) return;

        playBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (activeSlide && activeSlide !== slide) stopVideo(activeSlide);
          slide.classList.add('is-playing');
          video.currentTime = 0;
          video.muted = false;
          video.volume = 1;
          var p = video.play();
          if (p && p.catch) {
            p.catch(function () {
              /* Browser blocked sound — fall back to muted playback */
              video.muted = true;
              video.play();
            });
          }
          activeSlide = slide;
        });

        video.addEventListener('click', function () {
          stopVideo(slide);
          if (activeSlide === slide) activeSlide = null;
        });

        video.addEventListener('ended', function () {
          stopVideo(slide);
          if (activeSlide === slide) activeSlide = null;
        });
      });

      var track = section.querySelector('[data-stl-track]');
      var visTimer = null;
      if (track) {
        track.addEventListener('scroll', function () {
          clearTimeout(visTimer);
          visTimer = setTimeout(function () {
            if (!activeSlide) return;
            var t = track.getBoundingClientRect();
            var r = activeSlide.getBoundingClientRect();
            if (r.right <= t.left + 1 || r.left >= t.right - 1) {
              stopVideo(activeSlide);
              activeSlide = null;
            }
          }, 250);
        }, { passive: true });
      }
    }

    /* ---------- Product bubble slider + progress bar ---------- */
    function initProducts(section) {
      section.querySelectorAll('[data-stl-products]').forEach(function (wrap) {
        var track = wrap.querySelector('[data-stl-products-track]');
        var bar = wrap.querySelector('[data-stl-bar]');
        var thumb = wrap.querySelector('[data-stl-bar-thumb]');
        var pPrev = wrap.querySelector('[data-stl-pprev]');
        var pNext = wrap.querySelector('[data-stl-pnext]');
        if (!track) return;

        makeDrag(track, true);

        /* Scroll by one product card */
        function cardStep() {
          var card = track.querySelector('.stl-product-card');
          if (!card) return track.clientWidth;
          return card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
        }
        function go(dir) {
          return function (e) {
            e.preventDefault();
            e.stopPropagation();
            track.scrollBy({ left: dir * cardStep(), behavior: 'smooth' });
          };
        }
        if (pPrev) pPrev.addEventListener('click', go(-1));
        if (pNext) pNext.addEventListener('click', go(1));
        /* Keep arrow / scroll bar presses from dragging the main slider */
        if (bar) bar.addEventListener('mousedown', function (e) { e.stopPropagation(); });

        /* ---- Drag the scroll bar thumb (mouse + touch), or click the bar to jump ---- */
        var barTrack = bar ? bar.querySelector('.stl-products-bar') : null;
        if (barTrack && thumb) {
          var barDown = false, barStartX = 0, barStartScroll = 0;

          function scrollPerPixel() {
            /* how many px of content scroll per 1px of thumb movement */
            var free = barTrack.clientWidth - thumb.getBoundingClientRect().width;
            var max = track.scrollWidth - track.clientWidth;
            return free > 0 ? max / free : 0;
          }

          barTrack.addEventListener('pointerdown', function (e) {
            if (e.button !== undefined && e.button !== 0) return;
            e.preventDefault();
            e.stopPropagation();

            /* Clicked the empty part of the bar: centre the thumb on that spot first */
            if (!thumb.contains(e.target)) {
              var rect = barTrack.getBoundingClientRect();
              var thumbW = thumb.getBoundingClientRect().width;
              var target = (e.clientX - rect.left - thumbW / 2) * scrollPerPixel();
              track.classList.add('is-dragging');
              track.scrollLeft = target;
            }

            barDown = true;
            barStartX = e.clientX;
            barStartScroll = track.scrollLeft;
            barTrack.classList.add('is-dragging');
            track.classList.add('is-dragging'); /* no snapping while dragging */
            if (barTrack.setPointerCapture) barTrack.setPointerCapture(e.pointerId);
          });

          barTrack.addEventListener('pointermove', function (e) {
            if (!barDown) return;
            e.preventDefault();
            track.scrollLeft = barStartScroll + (e.clientX - barStartX) * scrollPerPixel();
          });

          function endBarDrag(e) {
            if (!barDown) return;
            barDown = false;
            barTrack.classList.remove('is-dragging');
            track.classList.remove('is-dragging'); /* snaps to the nearest card */
            if (barTrack.releasePointerCapture && e && e.pointerId !== undefined) {
              try { barTrack.releasePointerCapture(e.pointerId); } catch (err) {}
            }
          }
          barTrack.addEventListener('pointerup', endBarDrag);
          barTrack.addEventListener('pointercancel', endBarDrag);
          barTrack.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
        }

        function update() {
          if (!bar || !thumb) return;
          var max = track.scrollWidth - track.clientWidth;
          if (max <= 1) {
            bar.hidden = true;
            return;
          }
          bar.hidden = false;
          if (pPrev) pPrev.disabled = track.scrollLeft <= 1;
          if (pNext) pNext.disabled = track.scrollLeft >= max - 1;
          var ratio = track.clientWidth / track.scrollWidth;
          var progress = track.scrollLeft / max;
          thumb.style.width = (ratio * 100) + '%';
          thumb.style.transform = 'translateX(' + (progress * ((1 - ratio) / ratio) * 100) + '%)';
        }

        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
        update();
      });
    }

    /* ---------- Main carousel (infinite loop) ----------
       The slides are cloned once before and once after the real set:
       [clones][real slides][clones]. When scrolling settles inside a
       clone set, the track jumps instantly by one set width to the
       identical real slide, so the carousel never reaches an end. */
    function initCarousel(section) {
      var track = section.querySelector('[data-stl-track]');
      var next = section.querySelector('[data-stl-next]');
      var prev = section.querySelector('[data-stl-prev]');
      if (!track) return;

      var realSlides = Array.prototype.slice.call(track.querySelectorAll('[data-stl-slide]'));
      var n = realSlides.length;
      var loopEnabled = section.hasAttribute('data-stl-loop') && n > 1;
      var looping = false;
      var setWidth = 0;
      var step = 0;
      var animating = false;
      var targetX = 0;
      var animStart = 0;
      var touching = false;
      var settleTimer = null;

      function makeClone(slide) {
        var c = slide.cloneNode(true);
        c.classList.add('stl-slide--clone');
        c.classList.remove('is-playing', 'is-active');
        c.removeAttribute('data-shopify-editor-block');
        c.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
        c.querySelectorAll('video').forEach(function (v) { v.setAttribute('preload', 'none'); });
        return c;
      }

      if (loopEnabled) {
        var before = document.createDocumentFragment();
        var after = document.createDocumentFragment();
        realSlides.forEach(function (sl) { before.appendChild(makeClone(sl)); });
        realSlides.forEach(function (sl) { after.appendChild(makeClone(sl)); });
        track.insertBefore(before, track.firstChild);
        track.appendChild(after);
      }

      function measureStep() {
        var w = realSlides[0] ? realSlides[0].getBoundingClientRect().width : 0;
        return w + (parseFloat(getComputedStyle(track).columnGap) || 0);
      }

      /* Scroll instantly (ignores the CSS smooth scroll-behavior) */
      function jumpTo(x) {
        var prevBehavior = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = x;
        track.style.scrollBehavior = prevBehavior;
      }

      /* Which real slide (0..n-1) is at the left edge right now */
      function currentIndex() {
        if (!step) return 0;
        var offset = looping ? track.scrollLeft - setWidth : track.scrollLeft;
        return ((Math.round(offset / step) % n) + n) % n;
      }

      /* Decide if looping is needed (more slides than fit) and measure */
      function setup() {
        var idx = currentIndex();
        step = measureStep();
        if (!step) return;

        var visible = Math.max(1, Math.round(track.clientWidth / step));
        looping = loopEnabled && n > visible;
        track.classList.toggle('stl-no-loop', !looping);

        setWidth = looping
          ? realSlides[0].getBoundingClientRect().left - track.firstElementChild.getBoundingClientRect().left
          : 0;

        jumpTo(setWidth + idx * step);
        animating = false;
      }

      /* Keep the scroll position inside the real set */
      function normalize() {
        if (!looping || touching || track.classList.contains('is-dragging')) return;
        var x = track.scrollLeft;
        if (x < setWidth - 1) jumpTo(x + setWidth);
        else if (x >= setWidth * 2 - 1) jumpTo(x - setWidth);
      }

      function onSettle() {
        clearTimeout(settleTimer);
        /* An arrow animation is still on its way — don't interrupt it
           (safety valve after 1.5s in case it was cancelled) */
        if (animating && Math.abs(track.scrollLeft - targetX) > 2 && Date.now() - animStart < 1500) return;
        animating = false;
        normalize();
      }

      track.addEventListener('scroll', function () {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(onSettle, 140);
      }, { passive: true });
      if ('onscrollend' in window) track.addEventListener('scrollend', onSettle);

      track.addEventListener('touchstart', function () { touching = true; animating = false; }, { passive: true });
      track.addEventListener('mousedown', function () { animating = false; });
      track.addEventListener('touchend', function () {
        touching = false;
        clearTimeout(settleTimer);
        settleTimer = setTimeout(onSettle, 140);
      }, { passive: true });

      /* Arrows: always one slide, wraps around endlessly */
      function go(dir) {
        if (!step) step = measureStep();
        var base = animating ? targetX : track.scrollLeft;
        var target = (Math.round(base / step) + dir) * step;

        if (looping) {
          /* If the target leaves the real set, shift current position and
             target by one set width first — visually identical, so seamless */
          var shift = 0;
          if (target < setWidth - 1) shift = setWidth;
          else if (target >= setWidth * 2 - 1) shift = -setWidth;
          if (shift) {
            jumpTo(track.scrollLeft + shift);
            target += shift;
          }
        }

        targetX = target;
        animating = true;
        animStart = Date.now();
        track.scrollTo({ left: target, behavior: 'smooth' });
      }

      if (next) next.addEventListener('click', function () { go(1); });
      if (prev) prev.addEventListener('click', function () { go(-1); });

      makeDrag(track, false);

      var resizeTimer = null;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(setup, 150);
      });

      setup();
      /* Re-measure once images have loaded, in case sizes shifted */
      window.addEventListener('load', setup);
    }

    /* Touch screens have no hover: first tap on a slide reveals its products */
    function initTouchReveal(section) {
      if (!window.matchMedia('(hover: none)').matches) return;
      var slides = section.querySelectorAll('[data-stl-slide]');
      slides.forEach(function (slide) {
        slide.addEventListener('click', function (e) {
          if (e.target.closest('.stl-products, [data-stl-play]')) return;
          slides.forEach(function (s) { if (s !== slide) s.classList.remove('is-active'); });
          slide.classList.toggle('is-active');
        });
      });
    }

    function initAll() {
      document.querySelectorAll('.shop-the-look-section').forEach(function (section) {
        if (section.dataset.loaded) return;
        section.dataset.loaded = 'true';
        initCarousel(section); /* first: creates the loop clones */
        initVideos(section);
        initProducts(section);
        initTouchReveal(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
